<mds-dialog dialogTitle="Submit Stipend">
    <mds-dialog-content>
        <div class="o-grid">
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <span
                        >The field is pre-populated with the projected date. Please verify it before clicking
                        submit.</span
                    >
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <medpace-datepicker
                        [formCtrl]="generateStipendRequestFormGroup.controls.visitDateFormControl"
                        id="visitDate"
                        data-cy="visitDateDatepicker"
                        appearance="outline"
                        label="Visit Date"
                        [required]="true"
                    ></medpace-datepicker>
                </div>
            </div>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button [id]="'cancel-btn'" label="Cancel" (clickEvent)="closeDialog()" variant="outline"> </mds-button>
            <mds-button
                [id]="'confirm-btn'"
                id="changePatientStatusConfirmBtn"
                label="Confirm"
                (clickEvent)="saveDialog()"
                [color]="'primary'"
                [variant]="'filled'"
            >
            </mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
